import React from 'react';
import { bool, shape, string } from 'prop-types';

const ArrowUpColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5575 11.7802L9 8.34516L12.4425 11.7802L13.5 10.7227L9 6.22266L4.5 10.7227L5.5575 11.7802Z" fill="currentColor" />
  </svg>
);

ArrowUpColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default ArrowUpColor;
